<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="700px"
    append-to-body
    v-dialogDrag
    class="my_add_dialog"
    @close="close_dialog"
    :close-on-click-modal='false'
  >
    <div slot="title" class="dialog-header">
      <span v-if="type === 'page_add_row'" class="title">{{$t('components_my_add_button_my_add_dialog_2218')}}</span>
      <span v-else class="title">{{$t('widgets_basic_article_list_edit_400')}}</span>
    </div>
    <div class="dialog-body" v-loading="loading">
      <div class="select_title" v-if="type === 'page_add_row'">{{$t('components_my_add_button_my_add_dialog_2219')}}</div>
      <div class="jz_transfer">
        <div class="jz_transfer_panel jz_transfer_source">
          <div class="jz_transfer_operation">
            <div class="input_box">
              <el-input v-if="type === 'goodsList'" :placeholder="$t('components_my_add_button_my_add_dialog_2220')" size="medium" v-model="search_text"
                        @input="change_input"></el-input>
              <el-input v-else-if="type === 'articleList' || type === 'videoList'" :placeholder=" type === 'articleList' ? $t('components_my_add_button_my_add_dialog_2221'): $t('components_my_add_button_my_add_dialog_2227')" size="medium" v-model="search_text"
                        @input="change_input"></el-input>
              <el-input v-else-if="type === 'albumList'" :placeholder="$t('components_my_add_button_my_add_dialog_2222')" size="medium" v-model="search_text"
                        @input="change_input"></el-input>
              <el-input v-else :placeholder="$t('components_my_add_button_my_add_dialog_2223')" size="medium" v-model="search_text" @input="change_input"></el-input>
              <i class="input_box_icon el-icon-search" v-show="search_text === ''"></i>
              <i class="input_box_icon el-icon-error" v-show="search_text !== ''" @click="clear_input"></i>
            </div>
            <i class="el-icon-plus" @click="add_dialog_show = true" v-if="addIconVisible"></i>
          </div>
          <div class="jz_transfer_content">
            <div
              v-show="filterList.length > 0"
              class="jz_transfer_item"
              v-for="(item, index) in filterList"
              :key="item.id"
              @click="add_target(index)"
            >
              <div class="jz_transfer_label">{{ item.label }}</div>
            </div>
            <div class="jz_transfer_empty" :class="noDataClass" v-if="filterList.length <= 0">
              <div class="jz_transfer_empty_img"></div>
              <p class="jz_transfer_empty_label">{{ noDataTips }}</p>
            </div>
          </div>
        </div>
        <div class="jz_transfer_arrow">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="jz_transfer_panel jz_transfer_target">
          <div class="jz_transfer_content">
            <div class="jz_transfer_item" v-for="(item, index) in targetList" :key="item.id">
              <div class="jz_transfer_label" :title="item.label">{{ item.label }}</div>
              <div class="jz_transfer_button">
                <template v-if="type != 'page_add_row'">
                  <i
                    class="icon_arrow_up"
                    v-if="index !== 0"
                    :style="`marginRight: ${index === targetList.length - 1 ? 10 : 0}px`"
                    @click="up_target(index)"
                  ></i>
                  <i
                    class="icon_arrow_down"
                    v-if="index !== targetList.length - 1"
                    :style="`marginRight: ${index === 0 ? 10 : 0}px`"
                    @click="down_target(index)"
                  ></i>
                </template>
                <i
                  class="el-icon-close"
                  @click="delete_target(index)"
                  v-if="item.name != $store.state.app.now_page"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="is_copy_row" v-if="type === 'page_add_row'">
      <el-checkbox v-model="is_copy_row">{{$t('components_my_add_button_my_add_dialog_2224')}}</el-checkbox>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" size="medium" :disabled="!isSubmit">{{$t('view_public_topbar_15')}}</el-button>
      <el-button size="medium" @click="cancel">{{$t('view_public_topbar_14')}}</el-button>
    </div>
    <div v-if="type === 'goodsList'">
      <basic_addProduct
        v-if="add_dialog_show"
        @closed="child_dialog_close"
        :showTag.sync="add_dialog_show"
        @submit_sure="submit_sure"
      ></basic_addProduct>
    </div>
    <div v-if="type === 'articleList' || type === 'videoList'">
      <basic_addArticle
        v-if="add_dialog_show"
        :articleType="this.articleType"
        :showTag.sync="add_dialog_show"
        @submit_sure="submit_sure"
        @closed="child_dialog_close"
      ></basic_addArticle>
    </div>
    <div v-if="type === 'albumList'">
      <add_atlas v-if="add_dialog_show" @close="add_atlas_close" @submit_sure="submit_sure"></add_atlas>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {
  getGoodsList,
  get_atlas,
  getArticleListBy1,
  getRelationWidgetPage,
  getJobList
} from "@/api/app.js";
import {find_page} from "@/base/base"
import add_atlas from "@/components/basic_addAtlas"

export default {
  name: "my_add_dialog",
  components: {
    add_atlas
  },
  props: {
    type: {
      type: String,
      defalut: ""
    },
    selectIds: {
      type: Array,
      default: () => []
    },
    articleType: {
      type: Number,
      default: 1
    }
  },
  computed: {
    noDataClass() {
      if (this.filterList.length <= 0 && this.search_text !== '') {
        return 'is-no-match'
      } else if (this.sourceList.length <= 0) {
        return 'is-no-data'
      } else {
        return ''
      }
    },
    noDataTips() {
      if (this.filterList.length <= 0 && this.search_text !== '') {
        return i18n.t('components_my_add_button_my_add_dialog_2225', [this.tipsText])
      } else if (this.sourceList.length <= 0) {
        return i18n.t('components_my_add_button_my_add_dialog_2226', [this.tipsText])
      } else {
        return ''
      }
    },
    addIconVisible() {
      return this.type != 'page_add_row' && this.type !== 'jobList'
    }
  },
  watch: {
    targetList(val) {
      this.selectedIds = []
      val.map((item) => {
        this.selectedIds.push(item.id)
      })
    },
    is_copy_row(val) {
      this.isSubmit = true
    }
  },
  data() {
    return {
      loading: true,
      dialogVisible: true,
      search_text: "",
      sourceList: [],
      filterList: [],
      targetList: [],
      selectedIds: this.selectIds,
      add_dialog_show: false,
      is_copy_row: false,
      isSubmit: false,
      tipsText: '',
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    close_dialog() {
      this.$nextTick(() => {
        this.add_dialog_show = false;
      });
    },
    getList() {
      if (this.type === "goodsList") {
        this.get_goodsList();
        this.tipsText = i18n.t('widgets_basic_classification_edit_482')
      } else if (this.type === "albumList") {
        this.get_albumList();
        this.tipsText = i18n.t('components_basic_addarticle_index_2010')
      } else if (this.type === "articleList") {
        this.get_articleList();
        this.tipsText = i18n.t('base_options_config_1732')
      } else if (this.type === "videoList") {
        this.get_articleList();
        this.tipsText = i18n.t('view_download_index_181')
      } else if (this.type === "page_add_row") {
        this.get_page();
      } else if (this.type === 'jobList') {
        this.getJobList()
      } else if (this.type === "testList") {
        let _this = this;
        setTimeout(() => {
          _this.sourceList = [
            {label: 11, id: 1},
            {label: 22, id: 2},
            {label: 33, id: 3},
            {label: 44, id: 4},
            {label: 55, id: 5},
            {label: 66, id: 6},
            {label: 77, id: 7},
            {label: 88, id: 8},
            {label: 99, id: 9},
            {label: "aa", id: 10},
            {label: "bb", id: 11},
            {label: "cc", id: 12},
            {label: "dd", id: 13},
            {label: "ee", id: 14}
          ];
          _this.filter_selected();
        });
      }
    },
    get_page() {
      this.sourceList = this.$store.state.app.pages.map(item => {
        return {
          ...item,
          label: item.title
        };
      });
      this.getRelationWidgetPage();
    },
    //获取关联关系
    getRelationWidgetPage() {
      getRelationWidgetPage({
        widgets_id: this.$store.state.page_add_row.row.widgets_id
      }).then(e => {
        if (e.code == 200 && e.data && e.data instanceof Array) {
          e.data.map(item => {
            this.selectIds.push(item.id);
          });
          //判断是否存在当前页面，不存在则要插入一个
          const now_page_id = find_page(
            this.$store.state.app.now_page,
            this.sourceList
          ).id;
          //如果关联页面不存在当前页面，则强制加入一个
          if (now_page_id && this.selectIds.indexOf(now_page_id) == -1) {
            this.selectIds.unshift(now_page_id);
          }
          this.filter_selected();
        }
      }).finally(() => {
        this.loading = false
      });
    },
    get_goodsList() {
      getGoodsList({is_up: "true", hide: 'false', rows: 10000}).then(res => {
        if (res.code === 200) {
          this.sourceList = res.data.rows.map(item => {
            return {
              ...item,
              label: item.name,
              id: item.goods_id
            };
          });
          this.filter_selected();
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        this.$message.error(error);
      }).finally(() => {
        this.loading = false
      })
    },
    get_albumList() {
      get_atlas({status: 1,disabled: 'false', rows: 10000}).then(res => {
        if (res.code === 200) {
          this.sourceList = res.data.rows.map(item => {
            return {
              ...item,
              label: item.album_name
            };
          });
          this.filter_selected();
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        this.$message.error(error);
      }).finally(() => {
        this.loading = false
      })
    },
    get_articleList() {
      getArticleListBy1({type: this.articleType, is_up: 'true', rows: 10000}).then(res => {
        if (res.code === 200) {
          this.sourceList = res.data.rows.map(item => {
            return {
              ...item,
              label: item.title
            };
          });
          this.filter_selected();
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        this.$message.error(error);
      }).finally(() => {
        this.loading = false
      })
    },
    getJobList() {
      getJobList({
        page: 1,
        rows: 9999
      }).then(res => {
        if (res.code === 200) {
          this.sourceList = res.data.data.map(item => {
            return {
              ...item,
              label: item.subject,
            };
          });
          this.filter_selected();

          this.sourceList = this.sourceList.filter(item => {
            return !item.exp_date_end || new Date(item.exp_date_end * 1000).getTime() > new Date().getTime()
          })
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        this.loading = false
      })
    },
    add_target(index, isSubmit = true) {
      let item = this.filterList.splice(index, 1);
      this.targetList.push(...item);
      this.isSubmit = isSubmit
    },
    delete_target(index) {
      let item = this.targetList.splice(index, 1);
      this.filterList.push(...item);
      // this.sourceList.push(...item);
      this.isSubmit = true
    },
    up_target(index) {
      this.targetList.splice(index - 1, 0, this.targetList.splice(index, 1)[0]);
      this.isSubmit = true
    },
    down_target(index) {
      this.targetList.splice(index + 1, 0, this.targetList.splice(index, 1)[0]);
      this.isSubmit = true
    },
    confirm() {
      let ids = [];
      this.targetList.map(item => {
        ids.push(item.id);
      });
      this.$emit("confirm", ids, this.is_copy_row);
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false
      this.close_dialog()
    },
    close_dialog() {
      this.$emit("close");
    },
    filter_selected() {
      this.targetList = [];
      this.filterList = JSON.parse(JSON.stringify(this.sourceList));
      for (let i = 0; i < this.selectedIds.length; i++) {
        for (let k = 0; k < this.filterList.length; k++) {
          if (Number(this.selectedIds[i]) === Number(this.filterList[k].id)) {
            this.add_target(k, false);
          }
        }
      }
    },
    change_input() {
      let sourceList = [];
      this.sourceList.map(item => {
        let result = true;
        for (let i = 0; i < this.targetList.length; i++) {
          if (item.id === this.targetList[i].id) {
            result = false;
            break;
          }
        }
        if (result) {
          sourceList.push(item);
        }
      });
      if (this.search_text === "") {
        this.filterList = JSON.parse(JSON.stringify(sourceList));
      } else {
        this.filterList = sourceList.filter(item => {
          return String(item.label).indexOf(this.search_text) > -1;
        });
      }
    },
    clear_input() {
      this.search_text = ''
      this.change_input()
    },
    add_dialog_close() {
      console.log("add_Product_close");
    },
    submit_sure(newID) {
      //this.add_dialog_show = false
      this.getList()
    },
    add_atlas_close() {
      this.add_dialog_show = false
    },
    child_dialog_close() {
      this.add_dialog_show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";

.my_add_dialog {
  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: 100%;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
  }

  .dialog-header {
    height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #e3e2e8;

    .title {
      font-size: 16px;
      line-height: 1;
      color: #333;
      line-height: 50px;
    }

    .titleTip {
      font-size: 12px;
      line-height: 1;
      color: #666;
      margin-left: 5px;
      line-height: 50px;
    }
  }

  .dialog-body {
    padding-top: 35px;

    .select_title {
      margin: 0 0 14px 64px;
      font-size: 13px;
      color: #333;
    }

    .jz_transfer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .jz_transfer_panel {
        width: 250px;
        border: 1px solid #e3e2e8;
        display: inline-block;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #fff;
        vertical-align: middle;

        .jz_transfer_operation {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 10px 14px 1px 16px;

          .input_box {
            position: relative;

            /deep/ .el-input {
              .el-input__inner {
                padding-right: 32px;
              }
            }

            .input_box_icon {
              position: absolute;
              top: 0;
              right: 0;
              width: 32px;
              height: 36px;
              line-height: 36px;
              text-align: center;
              cursor: pointer;

              &.el-icon-error {
                color: #e4e4e4;
                font-size: 16px;
              }
            }
          }

          .el-icon-plus {
            margin-left: 16px;
            font-size: 18px;
            cursor: pointer;
          }
        }

        .jz_transfer_label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &.jz_transfer_source {
          .jz_transfer_content {
            overflow: auto;
            padding: 6px 0 0;
            height: 250px;

            .jz_transfer_item {
              padding: 0 6px;
              margin: 3px 10px;
              margin-right: 14px;
              height: 28px;
              line-height: 28px;
              cursor: pointer;

              &:hover {
                background: $theme-primary;
                color: #fff;
              }
            }
          }

          .jz_transfer_empty {
            &.is-no-data {
              .jz_transfer_empty_img {
                width: 140px;
                height: 135px;
                margin: 0 0 20px 90px;
                background: url(~@/assets/image/cssSprite.png) no-repeat -960px -266px;
              }
            }

            &.is-no-match {
              .jz_transfer_empty_img {
                width: 56px;
                height: 64px;
                margin: 52px auto 13px;
                background: url(~@/assets/image/cssSprite.png) no-repeat -1139px -268px;
              }
            }

            .jz_transfer_empty_label {
              text-align: center;
              color: #666;
            }
          }
        }

        &.jz_transfer_target {
          .jz_transfer_content {
            overflow: auto;
            height: 299px;

            .jz_transfer_item {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin: 7px 10px;
              height: 28px;
              line-height: 28px;

              .jz_transfer_label {
                flex: 1;
                overflow: hidden;
                display: inline-block;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-right: 12px;
                width: 150px;
              }

              .jz_transfer_button {
                i {
                  margin-right: 4px;
                  display: inline-block;
                  width: 17px;
                  height: 17px;
                  cursor: pointer;

                  &.el-icon-close {
                    margin-right: 0;
                    font-size: 18px;
                    line-height: 17px;
                    color: rgb(249, 146, 177);
                  }
                }

                .icon_arrow_up {
                  background: url(~@/assets/image/cssSprite.png) no-repeat;
                  background-position: -1029px -118px;

                  &:hover {
                    background-position-y: -72px;
                  }
                }

                .icon_arrow_down {
                  background: url(~@/assets/image/cssSprite.png) no-repeat;
                  background-position: -989px -118px;

                  &:hover {
                    background-position-y: -72px;
                  }
                }
              }
            }
          }
        }
      }

      .jz_transfer_arrow {
        padding: 0 22px;
        font-size: 30px;
      }
    }

  }

  .dialog-footer {
    width: 100%;
    text-align: center;
    display: block;
    padding-top: 20px;

    /deep/ .el-button {
      margin: 28px 18px;
      padding: 0 28px;
      height: 34px;
    }
  }

  .is_copy_row {
    padding-left: 63px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_add_button/my_add_dialog.vue